import { CategoryGroupLink, searchCategoryGroups } from '@/features/Settings/api/services/training/searchQuestionnaireCategoryGroups';
import { FilterOption, QuestionnaireCategory } from '@/models/gen/graphql';

import { getQuestionCountsByCategory } from '@/features/Settings/api/services/training/searchQuestionnaireQuestions';
import { getRoles } from '@/api/services/filters/roles';
import { searchCategoriesWithMetadata } from '@/features/Settings/api/services/training/searchQuestionnaireCategories';

export namespace TrainingCategoriesTypes {
  export type Filters = {
    name: string;
    roleId?: string;
  };
  export const initFilters: Filters = {
    name: '',
    roleId: undefined,
  };
  export type Modals = {
    categoryModal: {
      show: boolean;
      category?: QuestionnaireCategory;
    } | null;
  };
  export const initModals: Modals = {
    categoryModal: null,
  };
  export type State = {
    categories: QuestionnaireCategory[];
    categoryGroups: Record<string, CategoryGroupLink[]>;
    roles: FilterOption[];
    questionCounts: Record<string, number>;
    total: number;
    loading: boolean;
    filters: Filters;
    modals: Modals;
    fetch: () => Promise<void>;
    fetchRoles: () => Promise<void>;
    fetchQuestionCounts: () => Promise<void>;
    onReset: () => void;
    onSelectRole: (roleId: string) => void;
  };

  export const initState = (setState, getState) => {
    const fetch = async (): Promise<void> => {
      try {
        setState((current) => ({ ...current, loading: true }));
        const { state } = getState();
        const [{ categories, totalCount }, questionCounts] = await Promise.all([
          searchCategoriesWithMetadata(state.filters),
          getQuestionCountsByCategory(),
        ]);
        const links = await searchCategoryGroups((categories || []).map(({ id }) => id));
        const categoryGroups = links.reduce<Record<string, CategoryGroupLink[]>>((acc, link) => {
          (acc[link.questionnaireCategoryId] ||= []).push(link);
          return acc;
        }, {});
        setState((current) => ({ ...current, categories, categoryGroups, total: totalCount, questionCounts }));
      } catch (err) {
        console.error('Error fetching categories:', err);
      } finally {
        setState((current) => ({ ...current, loading: false }));
      }
    };
    return {
      categories: [],
      categoryGroups: {},
      roles: [],
      questionCounts: {},
      total: 0,
      loading: false,
      filters: initFilters,
      modals: initModals,
      fetch,
      fetchRoles: async (): Promise<void> => {
        try {
          setState((current) => ({ ...current, loading: true }));
          const roles = await getRoles();
          setState((current) => ({ ...current, roles }));
        } finally {
          setState((current) => ({ ...current, loading: false }));
        }
      },
      fetchQuestionCounts: async (): Promise<void> => {
        const questionCounts = await getQuestionCountsByCategory();
        setState((current) => ({ ...current, questionCounts }));
      },
      onReset: (): void => {
        setState((current) => ({ ...current, filters: { ...initFilters, roleId: current.filters.roleId } }));
        fetch();
      },
      onSelectRole: (roleId: string): void => {
        setState((current) => ({ ...current, filters: { ...current.filters, roleId } }));
        fetch();
      },
    };
  };
}
